module.exports = __webpack_public_path__ + "static/img/testBgItem3.d9ff526.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/testBgItem3.png
// module id = cOwF
// module chunks = 1